import React from "react";
import styles from './cotizacion.module.css';
import CumplirPropositos from "../../partials/cumplir-propositos";
import AlcanzarPropositos from "../../partials/alcanzar-propositos";
import Productos from '../productos';
import Beneficios from "../beneficios";
import Exclusiones from "../exclusiones";

const Cotizacion = ({ estaCargando, prospecto, pieChart, loadedPieChart, data, retorno, productos, tipoCambio, beneficios, exclusiones }) => {
    return (
        <React.Fragment>
            <div className={styles.wrapFirstcols}>
                <CumplirPropositos
                    name={estaCargando ? '' : prospecto.nombreCompleto}
                    data={pieChart}
                />
                <AlcanzarPropositos
                    loaded={loadedPieChart}
                    data={pieChart}
                />
            </div>
            <Productos
                datos={data}
                saldos={retorno}
                productos={productos}
                tipoCambio={tipoCambio}
            />
            <Beneficios beneficios={beneficios} />
            <Exclusiones exclusiones={exclusiones} />
        </React.Fragment>
    )
}

export default Cotizacion;